
import React from 'react';
import { Navbar } from '@/components/Navbar';
import ProfileSection from '@/components/ProfileSection';
import WebhookSettings from '@/components/WebhookSettings';
import { Wallet, Coins, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Profile = () => {
  // In a real app, this would come from your Stripe Connect status
  const isStripeConnected = true;
  
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <div className="max-w-md mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6">Profile</h1>
        
        <div className="space-y-6">
          <ProfileSection />
          
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="flex items-center gap-2 mb-4">
              <Wallet className="h-5 w-5 text-blue-500" />
              <h2 className="text-lg font-medium">Payment Receiving Settings</h2>
            </div>
            <p className="text-sm text-gray-500 mb-4">
              Configure your webhook to receive transaction fee notifications when payments are processed.
            </p>
            <div className="bg-blue-50 p-3 rounded-lg mb-4">
              <div className="flex gap-2 items-start">
                <Coins className="h-4 w-4 text-blue-600 mt-0.5" />
                <p className="text-xs text-blue-800">
                  You'll receive a 5% transaction fee notification for each payment processed.
                </p>
              </div>
            </div>
            
            <div className="bg-green-50 p-3 rounded-lg mb-4">
              <div className="flex gap-2 items-start">
                <Coins className="h-4 w-4 text-green-600 mt-0.5" />
                <div>
                  <p className="text-xs text-green-800 font-medium">
                    Stripe Connect Status: {isStripeConnected ? 'Connected' : 'Not Connected'}
                  </p>
                  <p className="text-xs text-green-700 mt-1">
                    Transaction fees are automatically transferred to your connected Stripe account.
                  </p>
                </div>
              </div>
            </div>
            
            <Button variant="outline" size="sm" className="w-full mt-2 flex items-center justify-center gap-2">
              <ExternalLink className="h-4 w-4" />
              Manage Stripe Connect Account
            </Button>
          </div>
          
          <WebhookSettings />
        </div>
      </div>
      <Navbar />
    </div>
  );
};

export default Profile;
